import { store } from '../../common/redux/configure-store';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { getEndorsementReceipt } from './services/get-endorsement-receipt';
import XLRLogger from 'src/common/helpers/logger';
import { EndorsementPrintDto } from 'src/devices/micr-utilities';
import { ITenderAdd } from 'src/common/interfaces/dtos/IPreTenderAdd';

export const getEndorsementReceipts = async (tenderDetails: ITenderAdd): Promise<IReceipt[]> => {
  const endorsementPrintDto = buildEndorsementPrintDto(tenderDetails);
  return getEndorsementReceipt(endorsementPrintDto).catch(err => {
    XLRLogger.error({
      message: 'Endorsement Receipt Request Failed.',
      source: 'handle-endorsement-receipts.ts',
    });
    throw err;
  });
};

const buildEndorsementPrintDto = (tenderDetails: ITenderAdd): EndorsementPrintDto => {
  return {
    utcDateTime: new Date().toUTCString(),
    isTrainingMode: store.getState().posMode.trainingMode,
    owner: {
      cashierUsername: store.getState().user.userName,
      cashierDisplayName: store.getState().user.displayName,
    },
    cartSequenceNumber: store.getState().transaction.sequenceNumber.toString(),
    tenderId: tenderDetails.tender?.tenderId,
    amount: tenderDetails.amount?.amount,
    cartTotalAmount: store.getState().itemList.amountDue,
  };
};
